import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { ToolsAction } from "../actions";
import * as toolApi from "../api/tool";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherToll() {
  yield takeLatest(types.TOOLS_LIST_REQUEST, worker);
  yield takeLatest(types.TOOLS_ALL_REQUEST, allWorker);
  yield takeLatest(types.TOOLS_SHOW_REQUEST, showWorker);
  yield takeLatest(types.TOOLS_STORE_REQUEST, store);
  yield takeLatest(types.TOOLS_UPDATE_REQUEST, updateWorker);
  yield takeLatest(types.TOOLS_REMOVE_REQUEST, removeWorker);
}

function* worker() {
  try {
    const response = yield call(fetchList);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data.data;
    yield put(ToolsAction.getListSuccess(data));
  } catch (error) {
    yield put(ToolsAction.getListFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchList() {
  return toolApi.getList();
}

function fetchAll() {
  return toolApi.getAll();
}

function* allWorker() {
  try {
    const response = yield call(fetchAll);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data.data;
    yield put(ToolsAction.getAllSuccess(data));
  } catch (error) {
    yield put(ToolsAction.getAllFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchShow(id) {
  return toolApi.show(id);
}

function* showWorker(action) {
  try {
    const response = yield call(fetchShow, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data.data;
    yield put(ToolsAction.showSuccess(data));
  } catch (error) {
    yield put(ToolsAction.showFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchStore(data) {
  return toolApi.store(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ToolsAction.storeSuccess(response.data.data));
  } catch (error) {
    yield put(ToolsAction.storeFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchUpdate(id, data) {
  return toolApi.update(id, data);
}

function* updateWorker(action) {
  try {
    const response = yield call(fetchUpdate, action.id, { ...action.data });
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data.data;
    yield put(ToolsAction.updateSuccess(data));
  } catch (error) {
    yield put(ToolsAction.updateFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function fetchRemove(data) {
  return toolApi.remove(data);
}

function* removeWorker(action) {
  try {
    const response = yield call(fetchRemove, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ToolsAction.removeSuccess(action.data, response.data.data));
  } catch (error) {
    yield put(ToolsAction.removeFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}
